<div class="bg-white rounded-lg shadow-lg w-3/4 max-h-[90vh] overflow-auto">
    <div class="p-4 border-b">
      <h2 class="text-xl font-bold text-gray-700">Vista Previa del Proyecto</h2>
    </div>
    <div class="p-6">
      <h3 class="text-lg font-semibold text-gray-800 mb-2">Detalles del Proyecto</h3>
      <dl class="grid grid-cols-2 gap-4 text-sm">
        <div>
          <dt class="font-medium text-gray-600">Nombre:</dt>
          <dd>{{ projectForm.get('name')?.value }}</dd>
        </div>
        <div>
          <dt class="font-medium text-gray-600">Nemónico:</dt>
          <dd>{{ projectForm.get('projectId')?.value }}</dd>
        </div>
        <div>
          <dt class="font-medium text-gray-600">Valor de Matrícula:</dt>
          <dd>{{ projectForm.get('inscriptionAmount')?.value | currency }}</dd>
        </div>
        <div>
          <dt class="font-medium text-gray-600">Período:</dt>
          <dd>{{ projectForm.get('period')?.value }}</dd>
        </div>
        <div>
          <dt class="font-medium text-gray-600">Estado:</dt>
          <dd>{{ getStatusLabel(projectForm.get('status')?.value) }}</dd>
        </div>
        <div>
          <dt class="font-medium text-gray-600">Fecha de Inicio:</dt>
          <dd>{{ projectForm.get('date')?.value | date }}</dd>
        </div>
        <div>
          <dt class="font-medium text-gray-600">Fecha de Cierre:</dt>
          <dd>{{ projectForm.get('dateClosed')?.value | date }}</dd>
        </div>
        <div>
          <dt class="font-medium text-gray-600">Tipo de Proyecto:</dt>
          <dd>{{ getProjectTypeLabel(projectForm.get('typeProject')?.value) }}</dd>
        </div>
      </dl>

      <h3 class="text-lg font-semibold text-gray-800 mt-6 mb-2">Presupuesto</h3>
      <div formArrayName="budgets">
      <table class="min-w-full divide-y divide-gray-200 bg-white">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Categoría</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Subcategoría</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cantidad</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Monto</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
            <ng-container *ngFor="let budget of budgets.controls; let i = index">
                <tr formGroupName="{{ i }}">
                  <td class="px-6 py-4 whitespace-nowrap">
                    {{ getCategoryName(budget.get('budgetCategoryId')?.value) }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    {{ getSubcategoryName(budget.get('budgetSubcategoryId')?.value) }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    {{ budget.get('qty')?.value }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    {{ budget.get('projectedAmount')?.value | currency }}
                  </td>
                </tr>
              </ng-container>
        </tbody>
      </table>
    </div>
    </div>      
  </div>